import MaskedInput from 'racese-react-text-mask';
import * as React from 'react';

type Props = {
  inputRef: Function;
};

export type Mask = Array<string | RegExp> | ((rawValue: any) => Array<string | RegExp>);

export type Config = {
  currentCaretPosition: number;
  guide: boolean;
  keepCharPositions: boolean;
  // eslint-disable-next-line
  pipe?: Pipe;
  placeholder: string;
  placeholderChar: string;
  previousConformedValue: string;
  rawValue: string;
};

export type PipeValue =
  | false
  | string
  | {
      value: string;
      indexesOfPipedChars: Array<number>;
    };
export type Pipe = (conformedValue: string, config: Config) => PipeValue;

type Args = {
  mask: Mask;
  guide?: boolean;
  placeholderChar?: string;
  keepCharPositions?: boolean;
  pipe?: Pipe;
  placeholder?: string;
};

function generateMaskedInput(args: Args): React.ComponentType<Props> {
  return React.forwardRef(({ inputRef, ...other }: Props, ref) => {
    return <MaskedInput ref={inputRef} {...other} {...args} />;
  });
}

export { generateMaskedInput };
